module.exports = __webpack_public_path__ + "img/v4_td3.c6e37c0c.png";